module.exports = __webpack_public_path__ + "static/img/genshin_background.c2a22b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/genshin_background.png
// module id = bN6R
// module chunks = 1